// map app locales to CMS locales
export const CMS_LOCALES = {
	'en-US': 'en',
	'fr-CA': 'fr-CA',
	'zh-CN': 'zh-CN'
};
